import { TranslationManager } from '../translations/TranslationManager';
import { useCallback } from 'react';

export const translate = (
  key: string,
  defaultResult: string = '',
  interpolations: { [key: string]: string } = {}
): string => {
  const manager = TranslationManager.getInstance();
  return manager.translate(key, defaultResult, interpolations);
};

export default function useTranslations() {
  const t = useCallback(
    (key: string, defaultResult: string = '', interpolations: { [key: string]: string } = {}): string => {
      if (typeof window === 'undefined') {
        return key;
      }
      // console.log('useTranslations hook called with key:', key);
      return translate(key, defaultResult, interpolations);
    },
    []
  );

  return t;
}
